<template>
  <div class="digit-pad" dir="ltr">
    <button
      v-for="key in keys"
      :key="key.id"
      type="button"
      class="digit-pad__key"
      :class="key.className"
      @click="$emit('press', key.value)"
    >
      <font-awesome-icon v-if="key.icon" :icon="key.icon" />
      <span v-else>{{ key.label }}</span>
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export type DigitPadValue = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '00' | '000' | 'delete' | 'backspace'

export default defineComponent({
  name: 'digit-pad',
  emits: ['press'],
  setup() {
    const keys: Array<{
      id: string
      label?: string
      value: DigitPadValue
      className?: string
      icon?: string[]
    }> = [
      { id: '7', label: '7', value: '7' },
      { id: '8', label: '8', value: '8' },
      { id: '9', label: '9', value: '9' },
      { id: '4', label: '4', value: '4' },
      { id: '5', label: '5', value: '5' },
      { id: '6', label: '6', value: '6' },
      { id: '1', label: '1', value: '1' },
      { id: '2', label: '2', value: '2' },
      { id: '3', label: '3', value: '3' },
      { id: '0', label: '0', value: '0' },
      { id: '00', label: '00', value: '00' },
      { id: '000', label: '000', value: '000', className: 'digit-pad__key--muted' },
      { id: 'delete', label: 'Delete', value: 'delete', className: 'digit-pad__key--delete digit-pad__key--span-2' },
      { id: 'backspace', value: 'backspace', className: 'digit-pad__key--backspace', icon: ['fas', 'arrow-left'] }
    ]

    return { keys }
  }
})
</script>

<style scoped>
.digit-pad {
  @apply grid gap-2;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  width: 16rem;
  max-width: 16rem;
}

.digit-pad__key {
  @apply flex items-center justify-center font-semibold select-none;
  min-height: 3rem;
  border-radius: 0.5rem;
  border: 1px solid #d8d8d8;
  background-color: #ececec;
  color: #333;
  transition: background-color 0.12s ease;
}

.digit-pad__key:hover {
  background-color: #e0e0e0;
}

.digit-pad__key:active {
  background-color: #d4d4d4;
}

.digit-pad__key--muted {
  background-color: #dedede;
  color: #444;
}

.digit-pad__key--muted:hover {
  background-color: #d0d0d0;
}

.digit-pad__key--delete {
  background-color: #fde8e8;
  color: #e35d5d;
  border-color: #f5c2c2;
}

.digit-pad__key--delete:hover {
  background-color: #fbd0d0;
}

.digit-pad__key--backspace {
  background-color: #fff3c4;
  color: #333;
  border-color: #f0e0a0;
}

.digit-pad__key--backspace:hover {
  background-color: #ffe9a0;
}

.digit-pad__key--span-2 {
  grid-column: span 2;
}

@screen md {
  .digit-pad {
    width: 16rem;
    max-width: 16rem;
  }

  .digit-pad__key {
    min-height: 3.1rem;
  }
}

@screen lg {
  .digit-pad {
    width: 16rem;
    max-width: 16rem;
  }

  .digit-pad__key {
    min-height: 3.25rem;
    font-size: 1.05rem;
  }
}
</style>
